import { render, staticRenderFns } from "./IconTypeformPhoneNumber.vue?vue&type=template&id=3cced6c6&"
import script from "./IconTypeformPhoneNumber.vue?vue&type=script&lang=ts&"
export * from "./IconTypeformPhoneNumber.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports